/* eslint-disable no-new, no-console, no-continue, guard-for-in, no-restricted-syntax */

import 'babel-polyfill';
import 'core-js/fn/object/assign';
import Vue from 'vue';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ru-RU';
import vueHeadful from 'vue-headful';
import Nl2br from 'vue-nl2br';
import axios from 'axios';

import store from './store/index';
import router from './router';
import App from './App';

import './conf/axios';

Vue.config.productionTip = false;
Vue.component('vue-headful', vueHeadful);
Vue.component('nl2br', Nl2br);
Vue.use(ElementUI, { locale });

Vue.mixin({

  computed: {
    curTheme() {
      return this.$store.getters['theme/curTheme'];
    },
    isMobile() {
      return window.orientation !== undefined;
    },
  },

  methods: {

    log(...args) {
      if (args.length && this.$store.state.showLogs) {
        console.log(...args);
      }
    },

  },
});

new Vue({
  created() {
    axios.interceptors.request.use((request) => {
      this.$store.commit('xhrActiveNumAdd');
      return request;
    });
    axios.interceptors.response.use((response) => {
      this.$store.commit('xhrActiveNumRem');
      return response;
    }, (error) => {
      this.$store.commit('xhrActiveNumRem');
      return Promise.reject(error);
    });
  },
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  computed: {
    showDepoAccessDenied() {
      return store.state.showDepoAccessDenied;
    },
  },
  watch: {
    showDepoAccessDenied(newVal) {
      if (newVal) {
        this.$alert('Чтобы депонировать объекты вам нужно быть сотрудником вуза-партнера. ' +
          'Вы можете зарегистрироваться на почту в домене вашего вуза или сменить почту в профиле.');
      }
      store.commit('setShowDepoAccessDenied', false);
    },
  },
});



// WEBPACK FOOTER //
// ./src/main.js